import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import cx from 'classnames';

import styles from './FieldLabel.scss';

// @todo move to or reuse from next-ui @feshchenko
// @TODO use `labelAlign` prop to provide label position customizability @sinslav
const FieldLabel = ({
  children,
  isError,
  disabled,
  isActive,
  text,
  onClick,
  className,
  disabledClassName,
  labelClassName,
}) => (
  <label className={labelClassName} onClick={onClick}>
    {text && (
      <span
        className={cx(styles.labelText, className, {
          [styles.disabledLabelText]: disabled,
          [styles.errorLabelText]: isError,
          [styles.activeLabelText]: isActive,
          [disabledClassName]: disabled,
        })}
      >
        {text}
      </span>
    )}
    {children}
  </label>
);

FieldLabel.propTypes = {
  text: PropTypes.node,
  disabled: PropTypes.bool,
  isError: PropTypes.bool,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  disabledClassName: PropTypes.string,
  labelClassName: PropTypes.string,
};

FieldLabel.defaultProps = {
  onClick: noop,
  disabledClassName: '',
  labelClassName: '',
};

export default FieldLabel;
